import React, { useEffect, useState } from 'react';

import { FilterItems } from '../../../../models/Specialist';

import Button from '../../../../components/Button';
import ContainerModal from '../../../../components/ContainerModal';

import { Container } from './style';
import { useContextSelector } from 'use-context-selector';
import { SpecialistContext, Filters } from '../../../../contexts/SpecialistContext';
import Accordion from '../Accordion';

type ModalFilterProps = {
  visible: boolean;
  units: FilterItems[];
  areaExpertises: FilterItems[];
  medicalFields: FilterItems[];
  onClose: () => void;
  onApply: (filters: Filters, isFilterVisible?: boolean) => void;
};

const initialFiltersState = { expertise: [], medicalField: [], units: [] };

export const ModalFilter: React.FC<ModalFilterProps> = ({
  visible,
  units,
  onClose,
  onApply,
  areaExpertises,
  medicalFields
}) => {
  const { selectedFilters, setSelectedFilters, handleCleanSelectedFilters } = useContextSelector(
    SpecialistContext,
    state => state
  );
  const [filters, setFilters] = useState<Filters>(selectedFilters);

  const handleApply = () => {
    setFilters(initialFiltersState);
    setSelectedFilters(filters);
    onApply(filters);
  };

  useEffect(() => {
    if (visible) setFilters(selectedFilters);
  }, [visible]);

  return (
    <ContainerModal
      visible={visible}
      headTitle="Filtrar"
      onClose={() => {
        onClose();
        setFilters(initialFiltersState);
      }}
      withoutCloseButton={true}
      childrenFooter={
        <Button
          disabled={!(filters.units.length || filters.medicalField.length || filters.expertise.length)}
          type="button"
          title="Aplicar"
          onClick={handleApply}
        />
      }
      rightText={filters.units.length || filters.medicalField.length || filters.expertise.length ? 'Limpar' : ''}
      onPressRightText={() => {
        setFilters(initialFiltersState);
        if (selectedFilters.units.length || selectedFilters.medicalField.length || selectedFilters.expertise.length) {
          handleCleanSelectedFilters();
          onApply(initialFiltersState, true);
        }
      }}
    >
      <Container>
        <Accordion
          isVisible={visible}
          onSelectItem={items => setFilters({ ...filters, units: items })}
          data={units}
          isMultipleSelect
          hasBorder={areaExpertises.length === 0 && medicalFields.length === 0 ? false : true}
          title="Unidades de atendimento"
          selectedFilters={filters.units}
          alreadySelectedFilters={selectedFilters.units}
        />

        <Accordion
          isVisible={visible}
          onSelectItem={items => setFilters({ ...filters, medicalField: items })}
          data={medicalFields}
          hasBorder={areaExpertises.length === 0 ? false : true}
          title="Área de atuação médica"
          selectedFilters={filters.medicalField}
          alreadySelectedFilters={selectedFilters.medicalField}
        />

        <Accordion
          isVisible={visible}
          onSelectItem={items => setFilters({ ...filters, expertise: items })}
          data={areaExpertises}
          title="Expertise médica"
          selectedFilters={filters.expertise}
          alreadySelectedFilters={selectedFilters.expertise}
        />
      </Container>
    </ContainerModal>
  );
};
